import {classNames} from '@cohort/shared-frontend/utils/classNames';
import PrimaryButton from '@cohort/wallet/components/button/PrimaryButton';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import {DownloadSimple} from '@phosphor-icons/react';
import React, {Fragment} from 'react';
import {useTranslation} from 'react-i18next';

interface NftTransferAcceptButtonProps {
  onAcceptNftButtonClicked: () => Promise<void>;
}

export const NftTransferAcceptButton: React.FC<NftTransferAcceptButtonProps> = ({
  onAcceptNftButtonClicked,
}) => {
  const {hasDarkBg} = useThemeContext();
  const {t} = useTranslation('components', {
    keyPrefix: 'space.nftTransfer.nftTransferAcceptButton',
  });

  return (
    <Fragment>
      <PrimaryButton
        testId="accept-nft-btn"
        text={t('acceptNftBtnText')}
        className="w-full"
        onClick={onAcceptNftButtonClicked}
        icon={<DownloadSimple className="h-5 w-5" aria-hidden="true" />}
        tracking={{namespace: 'digitalAssets.transfer.accept'}}
      />
      <p
        className={classNames(
          'mt-2 text-center text-sm md:text-left',
          hasDarkBg ? 'text-white/70' : 'text-black/70'
        )}
      >
        {t('acceptNftHelperText')}
      </p>
    </Fragment>
  );
};
NftTransferAcceptButton.displayName = 'NftTransferAcceptButton';
